// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__22p34","title":"Header_title__3NL8a","left":"Header_left__DgqLK","clinicName":"Header_clinicName__3L4q8"};